export default {
  timeRange: {
    ONE_DAY: '1 DAY',
    FIVE_DAYS: '5 DAYS',
    TEN_DAYS: '10 DAYS',
    ONE_MONTH: '1 MONTH',
  },

  LABEL_CHART_TOOLTIP_AVG: {
    ONE_DAY: 'Yesterday Total Trading Value: ',
    OTHERS: 'Average trading value %{timeRange}: ',
  },
  LABEL_CHART_TOOLTIP_TODAY: 'Today total trading value: ',
  LABEL_CHART_LEFT: 'Trading Value (Bn.)',
  LABEL_CHART_BOTTOM_TODAY: 'Today Total Trading Value',
  LABEL_CHART_BOTTOM_AVG: {
    OneDay: 'Yesterday Total Trading Value',
    OneWeek: 'Avg. Trading Value 5D',
    TwoWeeks: 'Avg. Trading Value 10D',
    OneMonth: 'Avg. Trading Value 1M',
  },
  busdTitle: 'Time & BU/SD Volume',
  footerNote: 'Volume: x1000, Price: x1000',
  footerNoteIndex: 'Volume: x1000',
};
